import { LoggerFactory } from '@videoblocks/typescript-logger';

import { SearchContentClass, typeaheadEndpoint } from '../StockblocksClient';
import { TypeaheadData } from './TypeaheadData';

const logger = LoggerFactory.create('fetchTypeahead');

export const fetchTypeahead = async (
    contentClass: SearchContentClass,
    keywords: string = '',
): Promise<TypeaheadData> => {
    try {
        if (!contentClass) {
            // @ts-expect-error suppressing this error as part of the ESLint strictness migration.
            return new Response('Missing contentClass', { status: 400 });
        }

        const result = await typeaheadEndpoint(contentClass, { keywords: keywords || '' });
        return result?.data;
    } catch (e) {
        logger.error({ err: e }, `Error fetching typeahead suggestions`);
        return {
            collections: [],
            keywords: [],
            latestCollections: [],
            relatedContentTypesAndKeywords: [],
            message: '',
        } satisfies TypeaheadData;
    }
};
